import request from '@/plugins/request';

export function pageInit(data) {
	return request({
		url: '/storagemanage/api/productShow/listProductShowInit',
		method: 'post',
		data: data
	});
}

export function GetDataList(data) {
	return request({
		url: '/storagemanage/api/productShow/listProductShow',
		method: 'post',
		data: data
	});
}

export function addPageInit(data) {
	return request({
		url: '/storagemanage/api/productShow/getProductShowCreateInit',
		method: 'post',
		data: data
	});
}

export function editPageInitReq(data) {
	return request({
		url: '/storagemanage/api/productShow/getProductShowEditInit',
		method: 'post',
		params: data
	});
}

export function AddOrEditData(data) {
	return request({
		url: '/storagemanage/api/productShow/saveProductShow',
		method: 'post',
		data: data
	});
}

export function getArea(data) {
	return request({
		url: '/storagemanage/api/area/getAreaSimpleList',
		method: 'post',
		data: data
	});
}

export function getAreaById(data) {
	return request({
		url: '/storagemanage/api/area/listArea',
		method: 'post',
		data: data
	});
}

export function deteleRecordReq(data) {
	return request({
		url: '/storagemanage/api/productShow/deleteProductShow',
		method: 'post',
		params: data
	});
}
